import React from 'react';
import './AboutCoaching.mobile.scss';
import useLanguage from '../../../languages/useLanguage';
import BorderedImage from '../../../blocks/BorderedImage';

function AboutCoachingMobile() {
  const language = useLanguage();

  return (
    <div className="about-coaching-mobile">
      <div className="about-coaching-content-mobile">
        <div className="introduction-mobile">
          <div>{language.aboutCoachingBody1}</div>
          <div>{language.aboutCoachingBody2}</div>
          <div>{language.aboutCoachingBody3}</div>
          <div>{language.aboutCoachingBody4}</div>
          <div>{language.aboutCoachingBody5}</div>
        </div>
        <div className="about-coaching-image-mobile">
          <BorderedImage borderColor="#d4b466" image="/images/why-coaching-04.png" />
        </div>
      </div>
      <div className="coaching-expectations-mobile">
        <div className="title">{language.aboutCoachingBody6}</div>
        <div className="pragmatism">
          <div className="subtitle">{language.aboutCoachingBody7}</div>
          <div className="text">{language.aboutCoachingBody8}</div>
        </div>
        <div className="no-agenda">
          <div className="subtitle">{language.aboutCoachingBody9}</div>
          <div className="text">{language.aboutCoachingBody10}</div>
        </div>
        <div className="listening">
          <div className="subtitle">{language.aboutCoachingBody11}</div>
          <div className="text">{language.aboutCoachingBody12}</div>
        </div>
      </div>
    </div>
  );
}

export default AboutCoachingMobile;
